<template>
  <div class="remote-consultation">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/" v-if="isZN">
          <el-breadcrumb-item>远程咨询</el-breadcrumb-item>
        </el-breadcrumb>
        <el-breadcrumb separator="/" v-else>
          <el-breadcrumb-item>远程医疗</el-breadcrumb-item>
          <el-breadcrumb-item>远程会诊</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3 v-if="isZN">远程咨询</h3>
      <h3 v-else>远程会诊</h3>
    </div>
    <div class="table-content"
         id="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input size="small"
                  placeholder="请输入"
                  width="264"
                  class="key-word"
                  v-model="keyword"></el-input>
        <span>会诊时间：</span>
        <el-date-picker v-model="conditionTime"
                        width="264"
                        type="daterange"
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
        <span>状态：</span>
        <el-select v-model="value"
                   size="small"
                   class="status">
          <el-option v-for="item in statusDatas"
                     :key="item.status"
                     :label="item.status"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary"
                   size="small"
                   v-if="isCompleted && isShowButton('查询')"
                   @click="search(keyword,value)">查询</el-button>
        <el-button size="small"
                   v-if="isCompleted && isShowButton('重置')"
                   @click="reset">重置</el-button>
        <el-button size="small"
                   type="primary"
                   v-if="isCompleted && isShowButton('会诊申请') && isZN"
                   @click="handleOption('新增')">咨询申请</el-button>
        <el-button size="small"
                   type="primary"
                   v-else="isCompleted && isShowButton('会诊申请')"
                   @click="handleOption('新增')">会诊申请</el-button>
      </div>
      <!-- 会诊申请对话框 -->
      <el-dialog :title="title"
                 :visible.sync="dialogShow"
                 :close-on-click-modal="false">
        <el-form :model="commonForm"
                 :rules="rules"
                 ref="commonForm">
          <el-row :gutter="3">
            <el-col :span="24">
              <el-form-item label="危急程度:"
                            :label-width="formLabelWidth"
                            prop="criticalLevel">
                <el-radio-group v-model="commonForm.criticalLevel">
                  <el-radio label="1">急诊</el-radio>
                  <el-radio label="0">普通</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="患者姓名:"
                            :label-width="formLabelWidth"
                            prop="name">
                <el-input v-model="commonForm.name"
                          auto-complete="off"
                          size="small"
                          placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="性别:"
                            :label-width="formLabelWidth">
                <el-radio v-model="commonForm.sex"
                          label="1">男</el-radio>
                <el-radio v-model="commonForm.sex"
                          label="2">女</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄:"
                            :label-width="formLabelWidth"
                            prop="age">
                <el-input-number v-model="commonForm.age"
                                 :precision="0"
                                 :min="0"
                                 :max="150"
                                 auto-complete="off"
                                 size="small"
                                 placeholder="请输入"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="identityCard">
            <el-col class="conditionTextarea"
                    :span="3">患者身份证号码:</el-col>
            <el-col :span="20">
              <el-input v-model="commonForm.identityCard"
                        placeholder="请输入患者身份证号码"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item prop="firstDiagnosis">
            <el-col class="conditionTextarea"
                    :span="3">患诊病情/初步判断:</el-col>
            <el-col :span="20">
              <el-input v-model="commonForm.firstDiagnosis"
                        type="textarea"
                        :rows="3"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item prop="illnessRemark">
            <el-col class="conditionTextarea"
                    :span="3">病情简介/会诊原因:</el-col>
            <el-col :span="20">
              <el-input v-model="commonForm.illnessRemark"
                        type="textarea"
                        :rows="3"></el-input>
            </el-col>
          </el-form-item>
          <el-row v-show="isShowConsultation">
            <el-col :span="12">
              <el-form-item label="会诊医院:"
                            :label-width="formLabelWidth"
                            size="small"
                            prop="diagnosisHospital">
                <el-select v-model="commonForm.diagnosisHospital"
                           @change="hospitalChange(commonForm.diagnosisHospital)">
                  <el-option v-for="(item,index) in commonForm.consultationHospitals"
                             :key="index"
                             :label="item.hospitalName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会诊医生:"
                            :label-width="formLabelWidth"
                            size="small"
                            prop="diagnosisDoctor">
                <el-select filterable
                           v-model="commonForm.diagnosisDoctor">
                  <el-option v-for="(item,index) in commonForm.consultationDoctors"
                             :key="index"
                             :label="item.userName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="选择日期:"
                            :label-width="formLabelWidth"
                            prop="diagnosisDate">
                <el-date-picker :picker-options="pickerOptions0"
                                type="datetime"
                                placeholder="选择日期"
                                v-model="commonForm.diagnosisDate"
                                style="width: 100%;"
                                size="small"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="11"
                    :offset="1">
              <el-form-item label="备注:"
                            :label-width="formLabelWidth">
                <el-input v-model="commonForm.remark"
                          auto-complete="off"
                          size="small"
                          placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-col :span="5"
                    class="consent">知情同意书拍照上传:</el-col>
            <el-col :span="15">

              <div class="add"
                   v-if="this.title == '新增申请'">
                <el-upload ref="upload"
                           :action="url"
                           class="upload-demo"
                           accept=".jpg,.jpeg,.png"
                           :file-list="fileList3"
                           list-type="picture"
                           :limit="1"
                           :on-success="success"
                           :auto-upload="false"
                           slot="reference"
                           :on-change="addchangeFile"
                           :on-preview="imgPreview">
                  <!-- <el-upload ref="upload" :action="url" class="upload-demo" accept=".jpg,.jpeg,.png,.pdf" :file-list="fileList3" list-type="picture" :limit="1" :on-success="success" :auto-upload="false" slot="reference" :on-change="addchangeFile"> -->
                  <el-button size="small"
                             type="primary">点击上传</el-button>
                  <span slot="tip"
                        class="el-upload__tip">&emsp;只能上传jpg/png文件，且不超过5M
                    <!-- <span :on-preview="imgPreview">图片预览</span> -->
                    <el-button type="text"
                               @click="handlePreview"
                               v-show="isShowPreview">&emsp;&emsp;点击预览PDF文件</el-button>
                  </span>
                </el-upload>
              </div>

              <div v-if="this.title == '编辑申请'">
                <!-- &lt;!&ndash;<img style="width: 60vw;" :src="this.imgUrl" />&ndash;&gt; -->
                <el-upload ref="upload"
                           :action="url"
                           class="upload-demo"
                           accept=".jpg,.jpeg,.png"
                           :file-list="fileList2"
                           list-type="picture"
                           :limit="1"
                           :on-success="editSuccess"
                           :auto-upload="false"
                           slot="reference"
                           :on-change="editchangeFile"
                           :on-preview="imgEditPreview">
                  <el-button class="marginRight10"
                             size="small"
                             type="primary">点击上传</el-button>
                  <span slot="tip"
                        class="el-upload__tip">&emsp;只能上传jpg/png文件，且不超过5M
                    <el-button type="text"
                               @click="handlePreview"
                               v-show="isShowPreview">&emsp;&emsp;点击预览PDF文件</el-button>
                  </span>
                </el-upload>
              </div>
            </el-col>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-row>
            <el-col :span="3"
                    :offset="1">
              <el-button type="text"
                         @click="download">
                <i class="el-icon-download el-icon--right"></i>知情同意书模板下载
              </el-button>
            </el-col>
            <el-col :span="2"
                    :offset="13">
              <el-button @click="dialogShow = false"
                         size="small">取 消</el-button>
            </el-col>
            <el-col :span="2"
                    :offset="2">
              <el-button :loading="isLoading"
                         type="primary"
                         @click="dialogShow = false,handleSubmit('commonForm')"
                         size="small">确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>

      <!-- 图片预览的模态框 -->
      <el-dialog title="图片预览"
                 :visible.sync="isShowImg"
                 @close="handlePreviewClose">
        <img style="width:100%;"
             :src="this.changeUrl"
             v-if="this.title == '新增申请'" />
        <img style="width:100%;"
             :src="this.imgUrl"
             v-else />
      </el-dialog>

      <!-- 表格 -->
      <el-table :data="remoteConsultation"
                v-loading="loading"
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left"
                     inline
                     class="demo-table-expand">
              <el-form-item label="患者病情简介:">
                <span>{{ props.row.illnessRemark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="患者姓名"
                         prop="name"
                         align="center"></el-table-column>
        <el-table-column label="性别"
                         prop="sex"
                         width="80px"
                         align="center"></el-table-column>
        <el-table-column label="年龄"
                         prop="age"
                         width="80px"
                         align="center"></el-table-column>
        <el-table-column label="会诊医院"
                         prop="diagnosisHospital"
                         align="center"></el-table-column>
        <el-table-column label="会诊医生"
                         prop="diagnosisDoctor"
                         align="center"></el-table-column>
        <el-table-column label="申请医院"
                         prop="applyHospital"
                         align="center"></el-table-column>
        <el-table-column label="申请医生"
                         prop="applyDoctor"
                         align="center"></el-table-column>
        <el-table-column label="会诊时间"
                         align="center"
                         min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.diagnosisDate | date}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         width="120px"
                         align="center">
          <template slot-scope="scope">
            <span :title="scope.row.cancelReason">
              {{scope.row.status}}
              <span style="background-color: green;color: white;font-size: 11px;border-radius: 3px"
                    v-if="scope.row.purchaseState==='已支付'">
                &nbsp;已支付&nbsp;
              </span>
              <span style="background-color: red;color: white;font-size: 11px;border-radius: 3px"
                    v-if="scope.row.purchaseState==='未支付'">
                &nbsp;未支付&nbsp;
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间"
                         align="center"
                         min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.createdTime | date}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="180px"
                         align="center">
          <div slot-scope="scope">
            <div v-for="(item,index) in scope.row.operation"
                 :key="index">
              <div v-if="item == '编辑'">
                <el-button type="text primary"
                           @click="handleOption('编辑',scope.row)">编辑</el-button>
              </div>
              <template v-else-if="item == '安排'">
                <el-button type="text primary"
                           @click="consultationArrange = true,arrange(scope.row)">安排</el-button>
              </template>
              <template v-else-if="item == '作废'">
                <el-popover placement="top"
                            width="172"
                            v-model="scope.row.isAbolish">
                  <p>
                    <i class="el-icon-error"
                       style="color:red;"></i>该操作不可逆,是否确认？
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini"
                               type="text"
                               @click="scope.row.isAbolish = false">取消</el-button>
                    <el-button type="primary"
                               size="mini"
                               @click="scope.row.isAbolish = false,abolish(scope.row.id)">确定
                    </el-button>
                  </div>
                  <el-button class="marginLeft10"
                             slot="reference"
                             type="text">作废</el-button>
                </el-popover>
              </template>
              <div v-else-if="item == '取消'">
                <el-popover placement="top"
                            width="200"
                            v-model="scope.row.isStop">
                  <p>取消理由</p>
                  <el-input v-model="cancelReason"
                            auto-complete="off"
                            size="mini"
                            placeholder="请输入"></el-input>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini"
                               type="text"
                               @click="scope.row.isStop = false">取消</el-button>
                    <el-button type="primary"
                               size="mini"
                               @click="scope.row.isStop = false,cancel(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference"
                             type="text"
                             class="cancel marginLeft10">取消</el-button>
                </el-popover>
              </div>
              <div v-else-if="item == '会诊'">
                <el-button type="text primary"
                           @click="handleConsultation(scope.row)"
                           class="marginRight10">会诊</el-button>
                <!-- <el-button type="text primary" @click="handleJianHu(scope.row)" class="marginRight10">监护</el-button> -->
              </div>
              <div v-else-if="item == '进入'">
                <el-button v-if="isZN" type="text primary"
                           @click="handleInto(scope.row)"
                           class="marginRight10">远程咨询</el-button>
                <el-button v-else type="text primary"
                           @click="handleInto(scope.row)"
                           class="marginRight10">进入</el-button>
              </div>
              <div v-else-if="item == '记录'">
                <el-button class="marginRight10"
                           type="text primary"
                           @click="consultationRecord = true, handeRecord(scope.row)">记录</el-button>
              </div>
            </div>
          </div>
        </el-table-column>
      </el-table>
      <!--分页  -->
      <div style="width:100%">
        <el-pagination style="width:100%"
                       background
                       @size-change='handleSizeChange'
                       @current-change='handleCurrentChange'
                       :current-page.sync='pageIndex'
                       :page-sizes='[10, 20, 30]'
                       :page-size='pageSize'
                       layout='total, sizes, prev, pager, next, jumper'
                       :total='total'>
        </el-pagination>
      </div>
    </div>
    <!-- 会诊安排对话框 -->
    <el-dialog title="会诊安排（可修改会诊医生、选择日期、增加邀请医院，邀请医生）"
               :visible.sync="consultationArrange"
               :before-close="handleClose">
      <el-form :model="arrangeForm2"
               :rules="rules"
               ref="consultationArrangeForm">
        <el-row :gutter="3">
          <el-col :span="8">
            <el-form-item label="患者姓名:"
                          :label-width="formLabelWidth">
              <el-input v-model="arrangeForm.name"
                        auto-complete="off"
                        size="small"
                        placeholder="请输入"
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="性别:"
                          :label-width="formLabelWidth">
              <el-radio v-model="arrangeForm.sex"
                        label="1"
                        disabled>男</el-radio>
              <el-radio v-model="arrangeForm.sex"
                        label="2"
                        disabled>女</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄:"
                          :label-width="formLabelWidth">
              <el-input v-model="arrangeForm.age"
                        auto-complete="off"
                        size="small"
                        placeholder="请输入"
                        disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="identityCard">
          <el-col class="conditionTextarea"
                  :span="3">患者身份证号码:</el-col>
          <el-col :span="20">
            <el-input v-model="arrangeForm.identityCard"
                      placeholder="请输入患者身份证号码"
                      disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col class="conditionTextarea"
                  :span="3">病情简介/会诊原因:</el-col>
          <el-col :span="20">
            <el-input type="textarea"
                      v-model="arrangeForm.illnessRemark"
                      rows="3"
                      placeholder="请输入"
                      disabled></el-input>
          </el-col>
        </el-form-item>
        <el-row :gutter="3">
          <el-col :span="12">
            <el-form-item label="会诊医院:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-select v-model="arrangeForm.diagnosisHospital"
                         placeholder="请选择"
                         disabled>
                <el-option v-for="item in arrangeForm.consultationHospitals"
                           :key="item.id"
                           :label="item.hospitalName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会诊医生:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-select filterable
                         v-model="arrangeForm.diagnosisDoctor"
                         placeholder="请选择">
                <el-option v-for="item in arrangeForm.consultationDoctors"
                           :key="item.id"
                           :label="item.userName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="选择日期:"
                          :label-width="formLabelWidth">
              <el-date-picker :picker-options="pickerOptions0"
                              type="datetime"
                              placeholder="选择日期"
                              v-model="arrangeForm.diagnosisDate"
                              style="width: 100%;"
                              size="small"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11"
                  :offset="1">
            <el-form-item label="备注:"
                          :label-width="formLabelWidth">
              <el-input v-model="arrangeForm.remark"
                        auto-complete="off"
                        size="small"
                        placeholder="请输入"
                        disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="3">
          <el-col :span="12">
            <el-form-item label="邀请医院:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-select filterable
                         v-model="arrangeForm2.invitationHospital"
                         clearable
                         placeholder="请选择"
                         @change="changeInvitateHospital(arrangeForm2.invitationHospital)">
                <el-option v-for="item in arrangeForm2.invitateHospitals"
                           :key="item.id"
                           :label="item.hospitalName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邀请医生:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-select filterable
                         clearable
                         v-model="arrangeForm2.invitationDoctor"
                         placeholder="请选择">
                <el-option v-for="item in arrangeForm2.invitateDoctors"
                           :key="item.id"
                           :label="item.userName"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="3">
          <el-col :span="12">
            <el-form-item label="是否同意:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-radio-group v-model="radio2">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会议室:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-select v-model="arrangeForm2.boardroom"
                         placeholder="请选择">
                <el-option v-for="item in arrangeForm2.boardrooms"
                           :key="item.hospitalId"
                           :label="item.hospitalName"
                           :value="item.hospitalId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <a v-if="arrangeForm.url"
             :href="arrangeForm.url.includes('http')? arrangeForm.url: 'http://' + arrangeForm.url"
             target="_blank">知情同意书预览</a>
        </el-row>
        <el-row v-if="radio2 == 0">
          <el-col :span="12">
            <el-form-item v-if="radio2 == 0"
                          label="拒绝原因:"
                          :label-width="formLabelWidth"
                          size="small">
              <!-- <el-select
                v-model="reason1"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择">
                <el-option
                  v-for="item in options5"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> -->
              <template>
                <el-checkbox-group v-model="checkList"
                                   @change="changeCheckBox">
                  <el-checkbox-button label="延期"></el-checkbox-button>
                  <el-checkbox-button label="系统错误"></el-checkbox-button>
                  <el-checkbox-button label="申请错误"></el-checkbox-button>
                </el-checkbox-group>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="拒绝原因:"
                          :label-width="formLabelWidth"
                          size="small">
              <el-input v-model="reason1"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-row>
          <el-col :span="2"
                  :offset="17">
            <el-button @click="consultationArrange = false"
                       size="small">取 消</el-button>
          </el-col>
          <el-col :span="2"
                  :offset="2">
            <el-button :loading="arrangeLoading"
                       v-if="radio2 == 1"
                       type="primary"
                       @click="arrangeSubmit()"
                       size="small">安 排</el-button>
            <el-button :loading="reasonLoading"
                       v-if="radio2 == 0"
                       type="primary"
                       @click="reason()"
                       size="small">拒 绝</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 会诊咨询意见 -->
    <div id="print1">
      <el-dialog title="会诊咨询意见（只能修改会诊时间和会诊咨询意见）"
                 :visible.sync="consultationRecord"
                 :before-close="handleClose">
        <el-form :model="consultationRecordForm"
                 :rules="rules"
                 ref="consultationRecordForm">
          <el-row :gutter="3">
            <el-col :span="8">
              <el-form-item label="患者姓名:"
                            :label-width="formLabelWidth">
                <el-input v-model="consultationRecordForm.name"
                          auto-complete="off"
                          size="small"
                          placeholder="请输入"
                          disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="性别:"
                            :label-width="formLabelWidth">
                <el-radio v-model="consultationRecordForm.sex"
                          label="1"
                          disabled>男</el-radio>
                <el-radio v-model="consultationRecordForm.sex"
                          label="2"
                          disabled>女</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄:"
                            :label-width="formLabelWidth">
                <el-input v-model="consultationRecordForm.age"
                          auto-complete="off"
                          size="small"
                          placeholder="请输入"
                          disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-col class="conditionTextarea"
                    :span="3">病情简介/会诊原因:</el-col>
            <el-col :span="20">
              <el-input type="textarea"
                        v-model="consultationRecordForm.illnessRemark"
                        rows="3"
                        placeholder="请输入"
                        disabled></el-input>
            </el-col>
          </el-form-item>
          <el-row>
            <el-col :span="11">
              <el-form-item label="会诊时间:"
                            :label-width="formLabelWidth"
                            prop="diagnosisDate">
                <el-date-picker :picker-options="pickerOptions0"
                                type="datetime"
                                placeholder="选择日期"
                                v-model="consultationRecordForm.diagnosisDate"
                                style="width: 100%;"
                                size="small"
                                :disabled="isDisabled"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="records">
            <el-col class="conditionTextarea"
                    :span="3">会诊咨询意见:</el-col>
            <el-col :span="20">
              <el-input type="textarea"
                        v-model="consultationRecordForm.records"
                        rows="3"
                        placeholder="请输入"
                        :disabled="isDisabled"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-row>
            <el-col :span="24"
                    style="text-align:center;">
              <el-button :loading="saveLoading"
                         style="margin:0 10px 0 0;"
                         type="button"
                         size="small"
                         @click="consultationRecord = false, handleRecordSave('consultationRecordForm')"
                         v-show="!isDisabled">保 存</el-button>
              <el-button :loading="submitLoading"
                         style="margin:0 10px 0 0;"
                         @click="consultationRecord = false ,consultationRecordSubmit('consultationRecordForm')"
                         size="small"
                         type="primary"
                         v-show="submitIsShow&&!isDisabled">提 交</el-button>
              <router-link target="_blank"
                           :to="{name: 'Print', query: {id: consultationRecordForm.id} }">
                <el-button type="primary"
                           size="small">打印预览</el-button>
              </router-link>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import isShowButton from '@/mixins'
import host from '../../mixins/host.js'
export default {
  mixins: [isShowButton, host],
  data() {
    return {
      rows: 3,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,
      arrangeLoading: false,  //安排按钮加载动画
      reasonLoading: false, //拒绝按钮加载动画
      isLoading: false, //按钮加载动画
      saveLoading: false,
      submitLoading: false,
      isShowConsultation: true,
      topHospitalId: localStorage.getItem('HospitalID'),
      radio2: 1, //是否同意安排
      reason1: '',
      checkList: [],
      isShowImg: false,
      remoteId: '',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      printRecord: false,
      hubUrl: '/api/chatHub',
      // hubUrl: 'http://wh.zkcis.com:8888/chatHub',
      connection: null,
      url: '/api/Remote/UploadFileAsync', //上传文件地址
      imgUrl: '', //后端返回的图片地址
      changeUrl: '', //用户修改文件的地址
      title: '', //会诊申请/编辑
      pageIndex: 1,
      pageSize: 10,
      totalCache: 0,
      isEdit: '',
      cancelReason: '', //取消理由
      isShow: null, //是否显示会诊申请按钮
      hospitalId: '',
      submitIsShow: null, //是否显示提交按钮
      isDisabled: null, //控制记录表单是否可读写
      isShowPreview: null, //是否显示预览按钮
      pdfUrl: null, //pdf文件预览地址
      value: '', //状态
      keyword: '', //关键词
      conditionTime: '', // 查询时间
      statusDatas: [
        {
          status: '会诊中',
          value: 3
        },
        {
          status: '新申请',
          value: 1
        },
        {
          status: '等待中',
          value: 2
        },
        {
          status: '已完成',
          value: 6
        },
        {
          status: '已取消',
          value: 4
        },
        {
          status: '已作废',
          value: 5
        }
      ],
      printForm: {
        name: '',
        sex: '',
        age: '',
        applyHospital: '',
        applyDoctor: '',
        createdTime: '', //申请时间
        diagnosisDate: '', //会诊时间
        invitationHospital: '',
        invitationDoctor: '',
        diagnosisHospital: '', //会诊医院
        diagnosisDoctor: '', //会诊医生
        firstDiagnosis: '', //患者病情
        illnessRemark: '', //会诊原因
        records: '', //建议
        imgBase64: '' //医生签名
      },
      // 表格
      remoteConsultation: [],
      loading: true,
      // 会诊申请弹出框
      dialogShow: false, //控制会诊申请弹出框显示/隐藏
      commonForm: {},
      otherForm: {},
      initForm: {
        diagnosisDoctor: '', //会诊医生
        hospitalName: '', //会诊医院
        criticalLevel: '', // 危急程度
        name: '',
        sex: '',
        age: null,
        identityCard: '', // 身份证号码
        conditionSynopsis: '',
        conditionDiagnosis: '',
        //会诊医院
        consultationHospitals: [
          {
            hospitalName: '医院1',
            id: null
          },
          {
            hospitalName: '医院2',
            id: null
          }
        ],
        // 会诊医生
        consultationDoctors: [
          {
            loginName: '医生1',
            id: null
          },
          {
            diagnosisDoctor: '医生2',
            id: null
          }
        ],
        date: '',
        remark: ''
      },
      fileList2: [], //编辑申请 文件列表
      fileList3: [], //新增申请 文件列表
      // 会诊安排弹出框
      consultationArrange: false, //控制会诊安排弹出框显示/隐藏
      arrangeForm: {
        name: '111', //姓名
        sex: '2', //性别
        age: 12, //年龄
        identityCard: '', // 患者身份证号码
        conditionSynopsis: 'emmm', //病情简介
        diagnosisDate: '', //会诊日期
        remarks: '', //备注
        diagnosisHospital: 1, //会诊医院
        //会诊医院
        consultationHospitals: [],
        diagnosisDoctor: 1, //会诊医生
        // 会诊医生
        consultationDoctors: [
          {
            consultationDoctor: '医生1',
            id: 1
          },
          {
            consultationDoctor: '医生2',
            id: 2
          }
        ],

      },
      arrangeForm2: {
        invitationHospital: '', //邀请医院
        invitateHospitals: [
          {
            id: 1,
            hospitalName: '医院1'
          }
        ],
        invitationDoctor: '', //邀请医生
        invitateDoctors: [
          {
            // id: 1,
            // invitationDoctor: '医生1'
          }
        ],
        boardroom: [], //会议室
        boardrooms: [
          {
            id: 1,
            boardroom: '会议室1'
          }
        ],
        diagnosisDate: '', //会诊日期
        diagnosisDoctor: '' //会诊医生
      },
      // 会诊咨询意见书
      consultationRecord: false, //控制会诊咨询意见书弹出框显示/隐藏
      consultationRecordForm: {
        name: '',
        sex: '',
        age: null,
        illnessRemark: '', //病情简介
        diagnosisDate: '', //会诊日期
        records: '' //记录
      },
      formLabelWidth: '80px', //lable标签的宽度
      // 表单验证规则
      rules: {
        criticalLevel: [
          { required: true, message: '请选择危急程度', trigger: 'change' }
        ],
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: ['blur', 'change']
          },
          {
            message: '长度太长，最大16个字符',
            trigger: ['blur', 'change'],
            max: 16
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: ['blur', 'change']
          }
        ],
        age: [
          {
            required: true,
            message: '年龄不能为空'
          }
          /* {
            message:'不能超过三个字符',
            max:3
          },*/
          /* {
            type: 'integer',
            message:'年龄必须为数字型',
            trigger: 'blur'
          }*/
        ],
        identityCard: [
          {
            required: true,
            message: '请输入患者身份证号码',
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
              var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
              var code = value.substring(17);
              if (p.test(value)) {
                var sum = 0;
                for (var i = 0; i < 17; i++) {
                  sum += value[i] * factor[i];
                }
                if (parity[sum % 11] == code.toUpperCase()) {
                  callback();
                  return true
                }
              }
              callback(new Error('输入的身份证号码有误'));
              return false;

            }, trigger: 'blur'
          }
        ],
        firstDiagnosis: [
          {
            required: true,
            message: '请输入病情诊断',
            trigger: ['blur', 'change']
          },
          {
            max: 200,
            message: '不能超过200个字符'
          }
        ],
        illnessRemark: [
          {
            required: true,
            message: '请输入病情原因',
            trigger: ['blur', 'change']
          },
          {
            max: 200,
            message: '不能超过200个字符'
          }
        ],
        diagnosisHospital: [
          {
            required: true,
            message: '请选择会诊医院',
            trigger: ['blur', 'change']
          }
        ],
        diagnosisDoctor: [
          {
            required: true,
            message: '请选择会诊医生',
            trigger: ['blur', 'change']
          }
        ],
        invitationHospital: [
          {
            required: true,
            message: '请选择邀请医院',
            trigger: ['blur', 'change']
          }
        ],
        invitationDoctor: [
          {
            required: true,
            message: '请选择邀请医生',
            trigger: ['blur', 'change']
          }
        ],
        records: [
          {
            required: true,
            message: '请输入会诊咨询意见书',
            trigger: ['blur', 'change']
          },
          {
            max: 1000,
            message: '不能超过1000个字符'
          }
        ],
        diagnosisDate: [
          {
            required: true,
            message: '请选择日期',
            trigger: ['blur', 'change']
          }
          //  { required: true, message: '请选择日期', trigger: 'change' }
        ],
        remark: [{ required: true, message: '请填写备注', trigger: ['blur', 'change'] }]
      },
    }
  },
  filters: {
    date(value) {
      value = moment(value).format('YYYY-MM-DD HH:mm')
      // console.log(typeof value)
      return value
    }
  },
  methods: {
    // 获取按钮权限
    // getBtnRole() {
    //   this.Axios.get('/api/User/GetUserBtnJurisdiction?menuID=' + this.menuId).then(res => {
    //     this.btnPremissionList = res.data.data
    //   })
    // },

    /* 这里的每一个方法最好都不要删 因为写到现在我也不知道我写的是什么了... */
    changeCheckBox() {
      // console.log(2222222)
      this.checkList.length > 1 ? this.reason1 = this.checkList.join(', ') : this.reason1 = this.checkList.join('')
    },
    // 拒绝安排
    reason() {
      // reasonLoading: false, //拒绝按钮加载动画
      // isLoading: false, //按钮加载动画
      this.reasonLoading = true
      this.consultationArrange = true
      this.Axios.put('/api/Remote/DisagreeRemote?id=' + this.arrangeForm.id + '&disagreeReason=' + this.reason1).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '拒绝成功!',
            type: 'success'
          })
          this.consultationArrange = false
          this.reasonLoading = false
          this.getTableData()
        } else {
          this.consultationArrange = true
          this.reasonLoading = false
          this.$message({
            showClose: true,
            message: '拒绝失败!',
            type: 'error'
          })
        }
      })
    },
    // 新增申请图片预览
    imgPreview(file) {
      this.changeUrl = file.url
      this.dialogShow = false
      this.isShowImg = true
    },
    // 图片编辑预览
    imgEditPreview(file) {
      this.imgUrl = file.url
      this.dialogShow = false
      this.isShowImg = true
    },
    printPriew() {
      // this.printRecord = true
      this.Axios.get('/api/Remote/GetPrintInfo?id=' + this.printForm.id)
        .then(res => {
          let data = res.data.data
          this.printForm = data
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    handleClose(done) {
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
      // this.$refs['consultationRecordForm'].resetFields();
    },
    handlePreviewClose() {
      this.isShowImg = false
      this.dialogShow = true
    },
    //预览PDf
    handlePreview() {
      window.open(this.pdfUrl)
    },
    // 监护跳转
    handleJianHu() {
      window.open('http://www.teleicu.cn:8000/monitor/?signalr=http://www.teleicu.cn:8000#/detail?bid=201810140901473632&wid=e14469cf-5e71-4c5a-a1fe-a557de17debf&bedNo=02床')
    },
    // 会诊
    handleConsultation(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.diagnosisDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)

      //获取当前时间
      let currentDate = new Date()
      //把当前时间转为时间戳
      let currentStamp = Date.parse(currentDate)
      if (dateStamp - currentStamp > 1200000) {
        this.$message({
          showClose: true,
          message: '会诊前二十分钟才能开始进行会诊!',
          type: 'error'
        })
      } else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${val.id}&type=1`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.getTableData()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get("/api/LiveCourse/RefreshStartUrl?ID="+val.id+"&type=2").then(res=>{
        //   if(res.data.status === 100){
        //     // console.log(res.data.startUrl)
        //     window.open(res.data.startUrl)
        //     this.getTableData()
        //   } else if(res.data.status === 200){
        //     this.$message({
        //       showClose: true,
        //       message: '内部异常联系管理员!',
        //       type: 'error'
        //     })
        //   } else {
        //     this.$message({
        //       showClose: true,
        //       message: '参数错误!',
        //       type: 'error'
        //     })
        //   }
        // })
      }
    },
    // 进入
    handleInto(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.diagnosisDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      //获取当前时间
      let currentDate = new Date()
      let currentStamp = Date.parse(currentDate)
      if (dateStamp - currentStamp > 1200000) {
        this.$message({
          showClose: true,
          message: '会诊前二十分钟才能进入!',
          type: 'error'
        })
      } else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${val.id}&type=1`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.Axios.get(`/api/Boardroom/JoinInfos?mid=${val.id}&type=1`).then(res => {
            })
            this.getTableData()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res=>{
        //   const data = res.data
        //   if (data.status === 100) {
        //     let url = val.joinUrl + '?zpk=' + data.data
        //     window.open(url)
        //     this.Axios.get('/api/Boardroom/JoinInfos?mid=' + val.id + '&type=1').then(res => {
        //       console.log('进入', res.data)
        //     })
        //   } else if (data.status === 200) {
        //     this.$message({
        //       showClose: true,
        //       message: '未查询到账号信息!',
        //       type: 'error'
        //     })
        //   }
        // })
        // this.getTableData()
      }
    },
    // 是否显示会诊申请按钮
    isShowApply() {
      this.Axios.get('/api/Remote/IsOpen')
        .then(res => {
          let data = res.data
          if (data.status == 100 && data.flag) {
            this.isShow = data.flag
            // this.dialogShow = data.flag
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 获取邀请医院
    getInvitateHospital() {
      this.Axios.get('/api/Hospital/GetAllHospital')
        .then(res => {
          let data = res.data
          this.arrangeForm2.invitateHospitals = data.data
          // this.arrangeForm2.invitateHospital = this.arrangeForm2.invitateHospitals[0].id
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 邀请医院改变时,获取相对应的邀请医生
    changeInvitateHospital(id) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id).then(res => {
        let data = res.data
        if (data.status == 100) {
          this.arrangeForm2.invitationDoctor = null
          this.arrangeForm2.invitateDoctors = data.data
        }
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 获取会议室
    getBoardroom() {
      this.Axios.get('/api/User/GetUserInfo')
        .then(res => {
          let data = res.data
          if (data.status == 100) {
            this.arrangeForm2.boardrooms = data.ret.boardroom.value
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error'
            });
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 安排 初始化数据
    arrange(val) {
      // this.arrangeForm2.invitationHospital = this.arrangeForm2.invitateHospitals[0].id
      let id = this.arrangeForm2.invitateHospitals[0].id
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id).then(res => {
        let data = res.data
        if (data.status == 100) {
          // this.arrangeForm2.invitationDoctor = data.data[0].id
          this.arrangeForm2.invitateDoctors = data.data
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
      this.arrangeForm2.invitationDoctor = null
      this.arrangeForm2.boardroom = null
      this.Axios.get('/api/Remote/GetRemoteConById?id=' + val.id)
        .then(res => {
          let data = res.data
          let hospitalId = data.data.diagnosisHospital
          var obj = {
            id: hospitalId,
            hospitalName: data.data.diagnosisHospitalName
          }
          this.arrangeForm.consultationHospitals = []
          this.arrangeForm.consultationHospitals.push(obj)
          this.arrangeForm.diagnosisHospital = hospitalId
          this.Axios.get(
            '/api/Hospital/GetDoctorByHId?hospitalId=' + hospitalId
          ).then(res => {
            if (res.data.status == 100) {
              this.arrangeForm.consultationDoctors = res.data.data
              Object.assign(this.arrangeForm, this.arrangeForm, data.data)
            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'error'
              });
            }
          })
          this.arrangeForm2.id = val.id
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员11',
            type: 'error'
          })
        })
    },
    // 添加安排
    addArrange() {
      let formData = {
        invitationHospital: this.arrangeForm2.invitationHospital,
        invitationDoctor: this.arrangeForm2.invitationDoctor,
        diagnosisDate: this.arrangeForm.diagnosisDate,
        diagnosisDoctor: this.arrangeForm.diagnosisDoctor,
        boardroom: this.arrangeForm2.boardroom
      }
      this.Axios.get(
        '/api/User/JudgeBoardroomInfo?time=' +
        moment(this.arrangeForm.diagnosisDate).format('YYYY-MM-DD HH:mm:ss') +
        '&boardroomId=' +
        this.arrangeForm2.boardroom
      ).then(res => {
        if (res.data.flag && res.data.status === 100) {
          this.$confirm('会议时间段有冲突，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.Axios.put(
                '/api/Remote/RemoteArrange?id=' + this.arrangeForm2.id,
                formData
              )
                .then(res => {
                  let data = res.data
                  if (data.status == 100) {
                    this.$message({
                      showClose: true,
                      message: '安排成功!',
                      type: 'success'
                    })
                    this.consultationArrange = false
                    this.getTableData()
                  } else if (data.status === 102) {
                    this.$message({
                      showClose: true,
                      message:
                        '添加瞩目会议室失败！会议室信息不正确，请联系管理员',
                      type: 'error'
                    })
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.message,
                      type: 'error'
                    })
                  }
                  this.arrangeLoading = false
                })
                .catch(error => {
                  this.arrangeLoading = false
                  this.$message({
                    showClose: true,
                    message: '网络错误，联系管理员',
                    type: 'error'
                  })
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        } else if (!res.data.flag && res.data.status === 100) {
          //没有冲突
          this.Axios.put(
            '/api/Remote/RemoteArrange?id=' + this.arrangeForm2.id,
            formData
          )
            .then(res => {
              let data = res.data
              if (data.status == 100) {
                this.$message({
                  showClose: true,
                  message: '安排成功!',
                  type: 'success'
                })
                this.consultationArrange = false
                this.getTableData()
              } else if (data.status === 102) {
                this.$message({
                  showClose: true,
                  message:
                    '添加瞩目会议室失败！会议室信息不正确，请联系管理员',
                  type: 'error'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                })
              }
              this.arrangeLoading = false
            })
            .catch(error => {
              this.arrangeLoading = false
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              })
            })
        } else {
          this.$message({
            showClose: true,
            message: '内部异常，请联系管理员',
            type: 'error'
          })
          this.arrangeLoading = false
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        })
        this.arrangeLoading = false
      })
    },
    // 会诊安排表单提交并验证
    arrangeSubmit() {
      this.arrangeLoading = true
      this.consultationArrange = true
      this.addArrange()
    },
    //获取会诊医院
    getHospital() {
      this.Axios.get('/api/Hospital/GetSuperiorHospital?hospitalID=' + this.topHospitalId)
        .then(res => {
          console.log('res: ', res)
          let data = res.data
          if (data.status == 100) {
            this.isShowConsultation = true
            this.initForm.consultationHospitals = data.data
          } else if (data.status == 101) {
            this.isShowConsultation = false
            // this.$message({
            //   showClose: true,
            //   message: '当前登录用户没有上级医院!',
            //   type: 'error'
            // })
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 会诊医院改变时,获取相对应的会诊医生
    hospitalChange(id) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id)
        .then(res => {
          this.commonForm.diagnosisDoctor = null
          let data = res.data
          if (data.status == 100) {
            // this.commonForm.diagnosisDoctor = null
            this.commonForm.consultationDoctors = data.data
          } else {
            this.commonForm.consultationDoctors = null
            this.$message({
              showClose: true,
              message: '该医院下没有医生!',
              type: 'error'
            })
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 文件上传成功时,上传数据
    success(response, file, fileList) {
      // debugger
      if (response.status === 100) {
        let formData = {
          Id: response.id, //文件id
          criticalLevel: this.commonForm.criticalLevel,
          name: this.commonForm.name,
          sex: this.commonForm.sex,
          age: this.commonForm.age,
          identityCard: this.commonForm.identityCard, // 患者身份证号码
          firstDiagnosis: this.commonForm.firstDiagnosis, //诊断
          diagnosisDoctor: this.commonForm.diagnosisDoctor, //会诊医生
          diagnosisHospital: this.commonForm.diagnosisHospital, //会诊医院
          illnessRemark: this.commonForm.illnessRemark, //病情简介
          diagnosisDate: moment(new Date(this.commonForm.diagnosisDate)).format(
            'YYYY-MM-DD HH:mm:ss'
          ), //会诊日期
          remark: this.commonForm.remark //备注
        }
        this.Axios.post('/api/Remote/AddRemoteCon', formData)
          .then(res => {
            const data = res.data
            if (data.status === 100) {
              this.isLoading = false
              this.dialogShow = false
              this.$message({
                showClose: true,
                message: '申请成功!',
                type: 'success'
              })
              this.getTableData()
              // this.$refs[formName].resetFields();
            } else {
              this.$message({
                showClose: true,
                message: data.message,
                type: 'error'
              })
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: '网络错误，联系管理员',
              type: 'error'
            })
          })
      }
    },
    // 没有修改文件 只上传数据
    edit(id) {
      let formData = {
        // Id: this.commonForm.id,  //文件id
        criticalLevel: this.commonForm.criticalLevel,
        name: this.commonForm.name,
        sex: this.commonForm.sex,
        age: this.commonForm.age,
        identityCard: this.commonForm.identityCard, // 患者身份证号码
        firstDiagnosis: this.commonForm.firstDiagnosis, //诊断
        diagnosisDoctor: this.commonForm.diagnosisDoctor, //会诊医生
        diagnosisHospital: this.commonForm.diagnosisHospital, //会诊医院
        illnessRemark: this.commonForm.illnessRemark, //病情简介
        diagnosisDate: this.commonForm.diagnosisDate, //会诊日期
        remark: this.commonForm.remark //备注
      }
      this.Axios.put('/api/Remote/UpdateRemoteCon?Id=' + id, formData)
        .then(res => {
          const data = res.data
          if (data.status === 100) {
            this.$message({
              showClose: true,
              message: '修改成功!',
              type: 'success'
            })
            this.getTableData()
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'error'
            });
          }
          this.isLoading = false
          this.dialogShow = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 修改了文件 上传数据
    editSuccess(response, file, fileList) {
      if (response.status == 100) {
        // this.fileList2[0].url = this.imgUrl
        let id = response.id
        let formData = {
          newid: id, //文件id
          criticalLevel: this.commonForm.criticalLevel,
          name: this.commonForm.name,
          sex: this.commonForm.sex,
          age: this.commonForm.age,
          identityCard: this.commonForm.identityCard, // 患者身份证号码
          firstDiagnosis: this.commonForm.firstDiagnosis, //诊断
          diagnosisDoctor: this.commonForm.diagnosisDoctor, //会诊医生
          diagnosisHospital: this.commonForm.diagnosisHospital, //会诊医院
          illnessRemark: this.commonForm.illnessRemark, //病情简介
          diagnosisDate: this.commonForm.diagnosisDate, //会诊日期
          remark: this.commonForm.remark //备注
        }
        this.Axios.put(
          '/api/Remote/UpdateRemoteCon?id=' + this.commonForm.id,
          formData
        )
          .then(res => {
            const data = res.data
            if (data.status === 100) {
              this.isLoading = false
              this.dialogShow = false
              this.$message({
                showClose: true,
                message: '修改成功!',
                type: 'success'
              })
              this.getTableData()
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: '网络错误，联系管理员',
              type: 'error'
            })
          })
      }
    },
    // 新增申请 修改文件
    addchangeFile(file, fileList) {
      // 获得上传文件名
      let fileName = fileList[0].name
      // 判断是否是PDF文件
      let isPdf = fileName.includes('pdf')
      if (isPdf) {
        this.isShowPreview = true
        this.pdfUrl = fileList[0].url
      } else {
        this.isShowPreview = false
      }
      this.fileList3 = fileList
      if (fileList.length <= 0) {
        this.changeUrl = null
        this.isShowPreview = false
      }
      this.changeUrl = fileList[0].url
      // console.log('filelist3',this.fileList3)
    },
    // 编辑申请 修改文件
    editchangeFile(file, fileList) {
      // 获得上传文件名
      let fileName = fileList[0].name
      // 判断是否是PDF文件
      let isPdf = fileName.includes('pdf')
      // console.log(isPdf)
      if (isPdf) {
        this.isShowPreview = true
        this.pdfUrl = fileList[0].url
      } else {
        this.isShowPreview = false
      }
      if (fileList.length <= 0) {
        this.imgUrl = null
      }
      this.imgUrl = fileList[0].url
      this.fileList2 = fileList
    },
    // 查询
    search() {
      this.getTableData()
    },
    // 知情同意书模板下载
    download() {
      this.Axios.get('/api/Remote/DownloadAgreement').then(res => {
        // console.log(res.data.url)
        window.open(res.data.url)
      })
    },
    // 修改会诊咨询意见书
    editRecord(isSubmit) {
      let formdata = {
        isCommit: isSubmit,
        name: this.consultationRecordForm.name, //患者姓名
        age: this.consultationRecordForm.age, //患者年龄
        sex: this.consultationRecordForm.sex, //患者性别
        records: this.consultationRecordForm.records, //记录
        illnessRemark: this.consultationRecordForm.illnessRemark, //病情简介
        diagnosisDate: this.consultationRecordForm.diagnosisDate //会诊日期
      }
      this.Axios.put(
        '/api/Remote/UpdateRecordById?id=' + this.consultationRecordForm.id,
        formdata
      )
        .then(res => {
          // console.log(res.data)
          let data = res.data
          if (data.status == 100) {
            this.$message({
              showClose: true,
              message: '修改成功!',
              type: 'success'
            })
            this.consultationRecord = false
            this.submitLoading = false
          } else {
            this.$message({
              showClose: true,
              message: '修改失败!',
              type: 'error'
            })
            this.consultationRecord = true
            this.submitLoading = true
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 记录
    handeRecord(val) {
      this.consultationRecordForm.id = val.id
      this.printForm.id = val.id
      this.Axios.get('/api/Remote/GetRecordById?id=' + val.id)
        .then(res => {
          let data = res.data
          this.consultationRecordForm = data.data
          if (data.data.isCommit == false) {
            this.isDisabled = false
          } else {
            this.isDisabled = true
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 获取表格数据
    getTableDataById() {
      this.loading = true
      this.Axios.get('/api/Remote/HomeJump?id=' + this.remoteId + '&type=' + 1)
        .then(res => {
          // console.log('aa', res)
          if (res.status === 200) {
            for (var i in res.data.data.ret) {
              if (res.data.data.ret[i].sex == '1') {
                res.data.data.ret[i].sex = '男'
              } else {
                res.data.data.ret[i].sex = '女'
              }
            }
            this.remoteConsultation = res.data.data.ret
            this.totalCache = res.data.data.total
            this.loading = false
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    getTableData() {
      const conditions = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (this.value != '') {
        conditions.status = this.value
      }

      if (this.keyword != '') {
        conditions.keyword = this.keyword
      }

      if (this.conditionTime && this.conditionTime.length === 2) {
        conditions.time = `${moment(this.conditionTime[0]).format('YYYY-MM-DD HH:mm:ss')},${moment(this.conditionTime[1]).format('YYYY-MM-DD 23:59:59')}`
      }

      this.loading = true
      this.Axios.get('/api/Remote/SearchRemoteConInfo', {
        params: conditions
      })
        .then(res => {
          const data = res.data
          for (let item of data.data.ret) {
            let itemArr = item.operation
            for (let itemStr of itemArr) {
              if (itemStr === '会诊') {
                this.submitIsShow = true
              }
            }
          }
          if (data.status === 100) {
            for (var i in data.data.ret) {
              if (data.data.ret[i].sex == '1') {
                data.data.ret[i].sex = '男'
              } else {
                data.data.ret[i].sex = '女'
              }
            }
            this.remoteConsultation = data.data.ret
            this.totalCache = data.data.total
            this.loading = false
          } else if (data.status === 102) {
            this.remoteConsultation = []
            this.loading = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 每页显示数改变
    handleSizeChange(val) {
      // console.log('每页显示数',val)
      this.pageSize = val
      this.getTableData()
    },
    // 当前页改变
    handleCurrentChange(val) {
      // console.log('当前页',val)
      this.pageIndex = val
      this.getTableData()
    },
    // 搜索/状态 重置
    reset() {
      this.keyword = null
      this.value = null
      this.conditionTime = null
      this.$route.query.id = ''
      this.getTableData()
    },
    // 取消
    cancel(id) {
      // console.log('取消id',id,this.cancelReason)
      this.Axios.put(
        '/api/Remote/CancelRemote?id=' +
        id +
        '&' +
        'cancelReason=' +
        this.cancelReason
      ).then(res => {
        // console.log('quxiao', res.data)
        let data = res.data
        if (data.status == 100) {
          this.$message({
            showClose: true,
            message: '取消成功!',
            type: 'success'
          })
          this.getTableData()
        } else {
          this.$message({
            showClose: true,
            message: '取消失败!',
            type: 'error'
          })
        }
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 作废
    abolish(id) {
      // console.log('作废id',id)
      this.Axios.put('/api/Remote/DiscardRemote?id=' + id)
        .then(res => {
          let data = res.data
          if (data.status == 100) {
            this.$message({
              showClose: true,
              message: '作废成功!',
              type: 'success'
            })
            this.getTableData()
          } else {
            this.$message({
              showClose: true,
              message: '作废失败!',
              type: 'error'
            })
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    },
    // 新增申请 编辑申请
    handleOption(option, val) {
      if (option === '新增') {
        this.commonForm = {}
        this.title = '新增申请'
        this.dialogShow = true
        this.commonForm = this.initForm
        for (let i in this.commonForm) {
          this.commonForm[i] = null
        }
        this.changeUrl = null
        this.fileList3 = []
        this.getHospital()
        this.commonForm.consultationHospitals = this.initForm.consultationHospitals
      } else if (option === '编辑') {
        this.title = '编辑申请'
        this.commonForm = this.initForm
        this.dialogShow = true
        // if (val.sex == '男') {
        //   this.commonForm.sex = '1'
        // }
        // 获取编辑的信息
        this.Axios.get('/api/Remote/GetRemoteConById?id=' + val.id).then(
          res => {
            let data = res.data
            this.hospitalId = data.data.diagnosisHospital
            this.Axios.get(
              '/api/Hospital/GetDoctorByHId?hospitalId=' + this.hospitalId
            ).then(res => {
              if (res.data.status == 100) {
                // this.commonForm.diagnosisDoctor = null
                console.log(data.data)
                // Object.assign(this.commonForm, this.commonForm, data.data)
                this.commonForm = data.data
                this.commonForm.consultationDoctors = res.data.data
                this.commonForm.criticalLevel = data.data.criticalLevel.toString()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                });
              }
            })
            let oldUrl = res.data.data.url //后端返回的图片的路径地址
            // console.log('编辑11111', res.data.data.url)
            // console.log('后端返回的图片地址',oldUrl)
            oldUrl = 'http://' + oldUrl
            let isPdf = oldUrl.includes('pdf')
            if (isPdf) {
              this.isShowPreview = true
              this.pdfUrl = oldUrl
            } else {
              this.isShowPreview = false
            }
            if (!oldUrl == '') {
              this.fileList2 = [{ url: oldUrl, name: '点击预览图片' }]
              this.imgUrl = oldUrl
            }
            this.commonForm.consultationHospitals = this.initForm.consultationHospitals
          }
        )
      }
    },
    // 新增申请,编辑申请表单提交
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === '新增申请') {
            if (this.fileList3.length >= 1) {
              this.$refs.upload.submit() //上传文件
              this.dialogShow = true
              this.isLoading = true
            } else {
              this.$message({
                showClose: true,
                message: '必须上传知情同意书!',
                type: 'error'
              })
              this.dialogShow = true
              return
            }
          } else if (this.title === '编辑申请') {
            if (this.imgUrl != '') {
              this.fileList2[0].url = this.imgUrl
            }
            let reg = /upload/
            var flag = reg.test(this.fileList2[0].url)
            // console.log('是否上传',flag)
            let id = this.commonForm.id
            if (!flag) {
              this.$refs.upload.submit()
              this.isLoading = true
              this.dialogShow = true
            } else {
              this.edit(id)
              this.isLoading = true
              this.dialogShow = true
            }
          }
        } else {
          // console.log("errorsubmit");
          this.dialogShow = true
          return false
        }
      })
    },
    // 会诊咨询意见书表单提交并验证
    consultationRecordSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log('idddd',this.consultationRecordForm.id)
          // console.log('isedit',this.isEdit)
          this.editRecord(true)
          this.consultationRecord = true
          this.submitLoading = true
        } else {
          // console.log('error submit!!')
          this.consultationRecord = true
          return false
        }
      })
    },
    //会诊咨询意见书表单保存并验证
    handleRecordSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log('idddd',this.consultationRecordForm.id)
          // console.log('isedit',this.isEdit)
          this.editRecord(false)
          this.consultationRecord = false
        } else {
          this.consultationRecord = true
          return false
        }
      })
    },
  },
  created() {
    // console.log('menuID', this.menuId)
    // console.log(this.isShowConsultation)
    // this.isShowConsultation = false
    // this.getBtnRole()
    if (this.$route.query.id == undefined || this.$route.query.id == '') {
      this.getBtnRole()
    }

    // this.connection = new signalR.HubConnectionBuilder()
    //   .withUrl(this.hubUrl)
    //   .build()
    // this.connection.start().catch(function(err) {
    //   return console.log('连接失败', err)
    // })
    // /*this.connection.on('RefreshForm', () => {
    //   this.getTableData()
    // })*/
    // this.connection.on('RefreshCallbackForm', () => {
    //   // console.log('回到')
    //   this.getTableData()
    // })
    // this.connection.onclose(() => {
    //   this.connection.start().catch(err => {
    //     return console.log('链接又失败了')
    //   })
    // })

    if (this.$route.query.id != undefined && this.$route.query.id != '') {
      this.remoteId = this.$route.query.id
      this.getTableDataById()
    } else {
      this.getTableData()
    }
    this.getHospital()
    this.isShowApply()
    this.getInvitateHospital()
    this.getBoardroom()
  },
  computed: {
    total() {
      return this.totalCache
    }
  },
  mounted() { }
}
</script>
<style scoped lang="less">
.remote-consultation {
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0px;
      .marginLeft10 {
        margin-left: 10px;
      }
      .marginRight10 {
        margin-right: 10px;
      }
      td div {
        display: inline-block;
      }
    }
    .el-pagination {
      /deep/ .number {
        background: #fff;
      }
    }
    .pageSize {
      margin-top: 25px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .consent {
      padding-left: 10px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .el-icon-upload2 {
      font-size: 14px;
      margin-right: 5px;
    }
    .el-icon-download {
      font-size: 20px;
    }
    .el-dialog__wrapper {
      /deep/ .el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
      }
      /deep/ .el-dialog__footer {
        border-top: 1px solid #d9d9d9;
      }
    }
    /deep/ .el-upload-list--picture .el-upload-list__item-name {
      cursor: pointer;
    }
    /deep/ .el-upload-list--picture .el-upload-list__item-name:hover {
      color: #66b1ff;
    }
  }
  /deep/ .el-form-item.is-required .el-form-item__label:before {
    margin-right: 0;
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__title {
      font-size: 14px;
    }

    /deep/ .el-dialog {
      width: 770px;
    }
    /deep/ .el-input--suffix {
      width: 234px;
    }
    /deep/ .el-textarea__inner {
      width: 620px;
    }

    .uploadBtn {
      margin-right: 10px;
    }
    .consent {
      padding-left: 10px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .textareaStyle {
      /deep/.el-textarea__inner {
        min-height: 75px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/Remote.vue